// extracted by mini-css-extract-plugin
export default {"wrapper":"BQ-z","availablePromoMessagesLabel":"CQ-z","promoMessageList":"DQ-z","promoMessage":"EQ-z","appliedPromoMessage":"FQ-z","promoMessageAmount":"GQ-z"};